/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
// import { ASSETS_TABLE } from "../pages/ListedAssetsTable/graphql/listed-asset-table.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {
    FEEDBACK_BUTTON,
    PRODUCT,
    PRODUCT_IMG,
    MODAL_FEEDBACK_CARD,
    PROMO_BUTTON,
    PROVENANCE,
} from "./config/product-view";
import { GET_PRODUCT } from "../pages/ProvenancePage/graphql/get-products.query";
import moment from "moment";
import { TOTAL_PROVENANCE } from "./config/trag.provenance";
import { NO_IMAGE } from "../assets/images";

const SERVICE_NAME = "product-provenance.service";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ProductProvenanceService {
    name = SERVICE_NAME;
    private static instance: ProductProvenanceService;

    private constructor() {
        this.report();
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new ProductProvenanceService();
        }
        return this.instance;
    }

    // _getImages(images: any) {
    //     let resultImg: any[] = [];
    //     images &&
    //         Array.isArray(images) &&
    //         images.forEach((item: any, index: number) => {
    //             if (item)
    //                 resultImg.push({
    //                     original: item,
    //                     thumbnail: item,
    //                     thumbnailHeight: "100",
    //                     thumbnailClass: "image-thumb",
    //                 });
    //         });
    //     return resultImg;
    // }

    _getImages = (images: any[]) => {
        let res =
            images &&
            Array.isArray(images) &&
            images.length > 0 &&
            images.map((item: any, index: number) => {
                if (item)
                    return {
                        original: item,
                        thumbnail: item,
                        thumbnailHeight: "70",
                        thumbnailClass: "image-thumb",
                    };
            });
        return res;
    };

    
    _getTimeline = (data: any) => {
        let _timeline: any[] = [];
        data &&
            Array.isArray(data) &&
            data.length > 0 &&
            data.map((item: any, index: number) => {
                item?.data &&
                    Array.isArray(item?.data) &&
                    item?.data.length > 0 &&
                    item?.data.map((ele: any, eleIndex: number) => {
                        _timeline.push({
                            id: ele?.credTxId,
                            key: ele?.gtinKey,
                            label: ele?.title,
                            subtitle: ele?.subtitle,
                        });
                    });
            });
        return _timeline;
    };

    _getSmTimeline = (data: any) => {
        let _timeline: any[] = [];
        data &&
            Array.isArray(data) &&
            data.length > 0 &&
            data.map((item: any, index: number) => {
                item?.data &&
                    Array.isArray(item?.data) &&
                    item?.data.length > 0 &&
                    item?.data.map((ele: any, eleIndex: number) => {
                        _timeline.push({
                            subtitle: ele?.subtitle,
                            tag: ele?.gtinKey,
                            title: ele?.title,
                            id: ele?.credTxId,
                        });
                    });
            });
        return _timeline;
    }

    _provenanceData = (data: any) => {
        let _provenance: any = {};
        let _data = data && Array.isArray(data) && data.length > 0 && data[0];
        _data =
            _data?.data &&
            Array.isArray(_data?.data) &&
            _data?.data.length > 0 &&
            _data?.data[0];

        return {
            idx: _data?.credTxId,
            title: _data?.title,
            subtitle: _data?.subtitle,
            // serialNo: 'Rare #/1',
            // img: "https://dev-dc.vlinder.io/imgsrv/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
            // // tag: 'DIAMOND',
            // // productCategory: 'collectibles',
            // // category: 'diamond',
            // price: [
            //     {
            //         type: "fiat",
            //         currency: "USD",
            //         locale: "en-US",
            //         amount: 1500.0,
            //     },
            //     {
            //         type: "crypto",
            //         currency: "ETH",
            //         amount: 0.5,
            //     },
            // ],
            // createdBy: {
            //     userName: "SWISS TIMING",
            //     userId: "swiss-timing",
            //     link: "/swiss-timing",
            //     authProofUrl:
            //         "https://gateway.pinata.cloud/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
            // },
            // meta: [
            //     {
            //         key: "Item",
            //         value: "Track & field starting block with loudspeaker",
            //     },
            //     {
            //         key: "Dimensions (LxWxH) ",
            //         value: "990 x 410 x 220 to 260 mm (depend to the position of the footrest)",
            //     },
            //     {
            //         key: "Weight",
            //         value: "13 KG",
            //     },
            //     {
            //         key: "Acoustic signals",
            //         value: "False start: 104 dB @ 1m, Gun shot: 114 dB @ 1m, 1x Tuchel 7pMT (for thrust sensors and loudspeaker)",
            //     },
            //     {
            //         key: "Operating temperature ",
            //         value: "0 to +50°C ",
            //     },
            //     {
            //         key: "Storage temperature  ",
            //         value: "-10°C to +60°C  ",
            //     },
            //     {
            //         key: "Protection",
            //         value: "IP44",
            //     },
            //     {
            //         key: "Certifications",
            //         value: "CE and RoHS compliant IAAF Certified Product",
            //     },
            // ],
            // // actions: [
            // //     {
            // //         key: "buyNowFiat",
            // //         title: "Buy in USD"
            // //     },
            // //     {
            // //         key: "buyNowCrypto",
            // //         title: " Buy in ETH"
            // //     }
            // // ],
            // images: [
            //     {
            //         original: NO_IMAGE,
            //         thumbnail: NO_IMAGE,
            //         thumbnailHeight: "70",
            //         thumbnailClass: "image-thumb",
            //     },
            // ],
        };
    };

    async productview(payload: string) {
        log.info(`in productView service.`, payload);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_PRODUCT,
                    variables: {
                        appMode: "web",
                        barcode: payload,
                    },
                    fetchPolicy: "network-only",
                });
                log.blue(`Products in service:`, res?.data?.getV2Provenance);
                let _data = res?.data?.getV2Provenance?.v2ProvData;
                if (_data)
                   
                    return {
                        title: _data?.product?.title,
                        subTitle: "Provenance Journey",
                        timeline: this._getTimeline(_data?.provenance?.data),
                        smtimeline: _data?.provenance?.data,
                        provenanceData: this._provenanceData(
                            _data?.provenance?.data
                        ),
                    };
            }
        } catch (err) {}
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
